import { sleep } from "../../../../util/util";

export type MultipleMonitorErrorType = "failed" | "unsupported";

export type MultipleMonitorCheckResult = {
  error?: MultipleMonitorErrorType;
  status: boolean;
};
export const checkMultipleMonitor =
  async (): Promise<MultipleMonitorCheckResult> => {
    await sleep();

    if ("isExtended" in window.screen) {
      const isExtended = window.screen.isExtended;
      if (isExtended === true) {
        return {
          error: "failed",
          status: false,
        };
      } else {
        return {
          status: true,
        };
      }
    } else {
      return { error: "unsupported", status: false };
    }
  };
